import { GeneralBtn } from '../../../../../../components';
import { Box } from '../../../../../../components/MuiGenerals';

interface IProps {
  onSearch: () => void;
  onReset: () => void;
}

const ActionButtons = (props: IProps) => {
  const { onSearch, onReset } = props;

  return (
    <Box display={'flex'} sx={{ gap: '24px' }}>
      <GeneralBtn label="apply" onClick={onSearch} />
      <GeneralBtn label="clear" onClick={onReset} />
    </Box>
  );
};

export default ActionButtons;
